import React, { useContext, useEffect, useState } from "react";
import PERFORMANCE from "../../../../Assets/Images/PERFORMANCE.png";
import STRATEGIC from "../../../../Assets/Images/STRATEGIC.png";
import VISIONARY from "../../../../Assets/Images/VISIONARY.png";
import COLLABORATIVE from "../../../../Assets/Images/COLLABORATIVE.png";
import HeaderPreview from "../../../GeneratePdf/HeaderPreview";
import FooterPreview from "../../../GeneratePdf/FooterPreview";
import { initialDataLeaderShip } from "../groupReport-pdf/QuadrantInFocus";
import GroupReportContext from "../../../../Context/GroupReportContext";
import { useGroupReportDate } from '../../../../Context/GroupReportDate';
import { logItemsOverviewData } from '../../../../utils/itemsOverviewLogger';

export const leadershipData = [
  {
    no: 1, score: 1,
    quadrant: "PERFORMANCE",
    question: "When leading through conflict, [First Name]’s goal is to accomplish our objective by any means necessary.",
    s: 3, m1: 4, d1: 3, p1: 3, p2: 4, o1: 3, a: 3,
  },
  {
    no: 1, score: 2,
    quadrant: "STRATEGIC",
    question: "When leading through conflict, [First Name] follows a specific process to work through it.",
    s: 4, m1: 3, d1: 3, p1: 3, p2: 3, o1: 3, a: 3,
  },
  {
    no: 1, score: 3,
    quadrant: "VISIONARY",
    question: "When leading through conflict, [First Name] can envision how this particular circumstance fits within a larger story.",
    s: 3, m1: 3, d1: 3, p1: 3, p2: 3, o1: 3, a: 3,
  },
  {
    no: 1, score: 4,
    quadrant: "COLLABORATIVE",
    question: "When leading through conflict, [First Name] is attuned to the feelings everyone is experiencing.",
    s: 3, m1: 3, d1: 3, p1: 3, p2: 3, o1: 3, a: 3,
  },
  {
    no: 2, score: 4,
    quadrant: "COLLABORATIVE",
    question: "[First Name] is at their best when feeling deeply connected to others.",
    s: 3, m1: 3, d1: 3, p1: 3, p2: 3, o1: 3, a: 3,
  },
  {
    no: 2, score: 1,
    quadrant: "PERFORMANCE",
    question: "[First Name] is at their best when driving others to deliver results.",
    s: 3, m1: 3, d1: 3, p1: 3, p2: 3, o1: 3, a: 3,
  },
  {
    no: 2, score: 3,
    quadrant: "VISIONARY",
    question: "[First Name] is at their best when casting a vision of where the team should be heading.",
    s: 3, m1: 3, d1: 3, p1: 3, p2: 3, o1: 3, a: 3,
  },
  {
    no: 2, score: 2,
    quadrant: "STRATEGIC",
    question: "[First Name] is at their best when creating standardized processes that help others achieve their goals more easily.",
    s: 3, m1: 3, d1: 3, p1: 3, p2: 3, o1: 3, a: 3,
  }
];


const sideLabels = [
  {
    "label": "CONFLICT",
    "bg": "#394554"
  },
  {
    "label": "PEAK PERFORMANCE",
    "bg": "#666666"
  },
  {
    "label": "GUIDING VALUES",
    "bg": "#394554"
  },
  {
    "label": "COMMITMENTS",
    "bg": "#666666"
  },
  {
    "label": "BELIEFS",
    "bg": "#394554"
  },
  {
    "label": "MOTIVATIONS",
    "bg": "#666666"
  },
  {
    "label": "DRIVERS",
    "bg": "#394554"
  },
  {
    "label": "COACHING",
    "bg": "#666666"
  },
  {
    "label": "INFLUENCE",
    "bg": "#394554"
  },
  {
    "label": "DIRECTION",
    "bg": "#666666"
  }
]

const Logo = (quadrant) => {
  switch (quadrant) {
    case 'PERFORMANCE':
      return <img style={{ width: "14px", padding: 0 }} src={PERFORMANCE} alt="PERFORMANCE" className="logo" />;
    case 'STRATEGIC':
      return <img style={{ width: "14px", padding: 0 }} src={STRATEGIC} alt="STRATEGIC" className="logo" />;
    case 'VISIONARY':
      return <img style={{ width: "14px", padding: 0 }} src={VISIONARY} alt="VISIONARY" className="logo" />;
    case 'COLLABORATIVE':
      return <img style={{ width: "14px", padding: 0 }} src={COLLABORATIVE} alt="COLLABORATIVE" className="logo" />;
    default:
      return null;
  }
};

const LeadershipItemOverview360 = ({ apiData, reportType, pageNumber }) => {
  const [dynamicData, setDynamicData] = useState([...leadershipData]);
  const groupReportCtx = useContext(GroupReportContext)
  const { updateTablevaluels2Page1 } = useGroupReportDate();
  const respondentName = apiData?.fullName?.split(' ')[0] || '[First Name]';

  const allMembersDataArray = Object.values(apiData?.memberResults?.allMembersData || {});
  const allVariableSets = allMembersDataArray.map(el => el.variables);
  const allAssessmentDesignation = allMembersDataArray.map(el => el?.designation);
  const allAssessmentHash = allMembersDataArray.map(el => el?.hash);
  const allAssessmentFullName = allMembersDataArray.map(el => el?.fullName);
  const displayData = dynamicData;

  const quadrantScores = {
    "PERFORMANCE": 1,
    "STRATEGIC": 2,
    "VISIONARY": 3,
    "COLLABORATIVE": 4
  }


  const allResults = [];
  displayData?.forEach((el, index) => {
    const res = groupReportCtx?.calculateQuestionScoreLeadership(quadrantScores?.[el.quadrant], allVariableSets, el.no, "360_overview", allAssessmentDesignation, allAssessmentHash, allAssessmentFullName);
    if (res?.averageScore !== null) {
      allResults.push(res);
    }
  })

  // Collect all scores and save to context (page1)
  useEffect(() => {
    if (allResults?.length > 0) {
      const scoresArray = [];

      // Get first 12 items (as shown in the slice)
      const first12Items = dynamicData.slice(0, 8);

      first12Items.forEach((item, index) => {
        const selfScore = groupReportCtx?.getAverageScore("360 Assessment", allResults, index);
        const managerScore = groupReportCtx?.getAverageScore("360 Assessment Manager", allResults, index);
        const directReportScore = groupReportCtx?.getAverageScore("360 Assessment Direct Report", allResults, index);
        const peerScore = groupReportCtx?.getAverageScore("360 Assessment Peer", allResults, index);
        const otherScore = groupReportCtx?.getAverageScore("360 Assessment Other", allResults, index);
        const averageScore = groupReportCtx?.getObserverAverageScore(allResults, index) ?? "-";

        // Create array with scores only: [selfScore, managerScore, directReportScore, peerScore, otherScore, averageScore]
        const itemScores = [selfScore, managerScore, directReportScore, peerScore, otherScore, averageScore];
        scoresArray.push(itemScores);
      });

      // Save to context in page1 format
      updateTablevaluels2Page1(scoresArray);
      logItemsOverviewData({
        pageName: "Leadership Flow 1",
        items: first12Items,
        allResults,
        getAverageScore: groupReportCtx.getAverageScore,
      });
    }
  }, [allResults, dynamicData, groupReportCtx]);

  return (
    <div style={{ backgroundColor: "rgb(255, 255, 255)" }}>
      <HeaderPreview />
      <div className="page" style={{ paddingBottom: "0", height: "634px", boxSizing: "border-box", position: "relative" }}>
        <div className="headerBox">
          <h2 className="title">LEADERSHIP FLOW 360 ITEMS OVERVIEW</h2>
          <p className="subTitle"> This page presents a ranking of all 40 items distributed across the four quadrants: Collaborative, Visionary, Strategic, and Performance. The rankings are based on the OBSERVER ratings (SELF excluded), using a response scale that ranges from 1 (Least) to 4 (Most). Any unselected statement will appear as "-" in the Items Overview chart. </p>
        </div>

        <div className="content">
          <div className="table" style={{ position: "relative" }}>
            <div className="tableRow tableHeader" style={{ background: "#245775", color: "#fff", display: "flex", zIndex: "1", position: "relative" }}>
              <div className="cellIndex" style={{ display: "flex", alignItems: "center", marginLeft: "40px" }}>#</div>
              <div className="cellQuadrant" style={{ fontSize: "9px", padding: "5.5px 0px 5.5px 13px", lineHeight: "13px" }}>Quadrant</div>
              <div className="cellLogo" style={{ width: "9%" }} ></div>
              <div className="cellQuestion" style={{ paddingLeft: "10px" }}>Question</div>
              <div className="cellscore-parent" style={{ display: "flex", marginLeft: "16px" }}>
                <div className="cellScore">S</div>
                <div className="cellScore">M</div>
                <div className="cellScore">D</div>
                <div className="cellScore">P</div>
                <div className="cellScore">O</div>
                <div className="cellScore">A</div>
              </div>
            </div>

            {dynamicData.slice(0, 8).map((item, index) => {
              const selfScore = Number(groupReportCtx?.getAverageScore("360 Assessment", allResults, index));
              const managerScore = Number(groupReportCtx?.getAverageScore("360 Assessment Manager", allResults, index));
              const directReportScore = Number(groupReportCtx?.getAverageScore("360 Assessment Direct Report", allResults, index));
              const peerScore = Number(groupReportCtx?.getAverageScore("360 Assessment Peer", allResults, index));
              const otherScore = Number(groupReportCtx?.getAverageScore("360 Assessment Other", allResults, index));
              const averageScore = Number(groupReportCtx?.getObserverAverageScore(allResults, index));
              const getLabelByIndex = (idx) => {
                if (idx === 0) {
                  return sideLabels[0].label;
                }
                return sideLabels[Math.floor(idx / 4)]?.label;
              };
              const getStyleByIndex = (idx) => {
                if (idx === 0) {
                  return { top: "12px", height: "50%", backgroundColor: sideLabels[0].bg };
                }
                return { top: "53%", height: "50%", backgroundColor: sideLabels[Math.floor(idx / 4)]?.bg };
              };

              return <div key={index} style={{ display: "flex", alignItems: "center", padding: "5px 0", }} className={`tableRow ${index % 2 === 0 ? 'evenRow' : 'oddRow'}`}>
                <div className='cellIndex'></div>
                {index === 0 || index % 4 === 0 ? (
                  <div className="sidelables" style={getStyleByIndex(index)}>
                    {getLabelByIndex(index)}
                  </div>
                ) : null}
                <div className="cellIndex" style={{ marginLeft: "30px" }}>{index + 1}.</div>
                <div className="cellQuadrant" style={{ width: "75px", marginLeft: "11px" }}>{item.quadrant}</div>
                <div className="cellLogo">{Logo(item.quadrant)}</div>
                <div className="cellQuestion">{item.question.replace(/\[First Name\]/g, respondentName)}</div>
                <div className="cellScore-parent" style={{ display: "flex", alignItems: "center", marginLeft: "" }}>
                  <div className="cellScore">{Number.isNaN(selfScore) ? "-" : selfScore.toFixed(1)}</div>
                  <div className="cellScore">{Number.isNaN(managerScore) ? "-" : managerScore.toFixed(1)}</div>
                  <div className="cellScore">{Number.isNaN(directReportScore) ? "-" : directReportScore.toFixed(1)}</div>
                  <div className="cellScore">{Number.isNaN(peerScore) ? "-" : peerScore.toFixed(1)}</div>
                  <div className="cellScore">{Number.isNaN(otherScore) ? "-" : otherScore.toFixed(1)}</div>
                  <div className="cellScore">{averageScore === 0 || Number.isNaN(averageScore) ? "-" : averageScore.toFixed(1)}</div>
                </div>
              </div>
            })}
          </div>
        </div>
        <p className='explain-para' style={{ fontSize: "9px", color: "#00577D", fontWeight: "400", lineHeight: "13px", marginTop: "auto" }}>
          Observer ratings are grouped by relationship (Manager, Direct Report, Peer, Other), with each column showing the group’s average score. The final column displays the overall observer average; the Self score is excluded.
        </p>
        <div className='details-footer' style={{ background: "#EAF1F5", fontSize: "10px", fontWeight: "400", margin: "0", padding: "4px 10px", height: "20px", marginTop: "16px", marginBottom: "4px" }}>
          <ul className='details-list'>
            <li>S - Self</li>
            <li>M - Manager</li>
            <li>D - Direct Report</li>
            <li>P - Peer</li>
            <li>O - Other</li>
            <li>A - Average</li>
          </ul>
        </div>
      </div>
      <FooterPreview pageNumber={pageNumber} reportType={reportType} />
    </div>
  );
};

export default LeadershipItemOverview360;
